module.exports = __webpack_public_path__ + "static/media/pic1.cb531365.png";